import React from 'react';
import { motion } from 'framer-motion';
import { Shield, Lock, CreditCard } from 'lucide-react';
import { trackAddToCart } from '../hooks/useMetaPixel';
export function PricingCTA() {
  return <section id="pricing" className="py-14 md:py-24 px-4 bg-forest-800 relative overflow-hidden" data-id="element-116">
      {/* Glow effects */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-gold-500 rounded-full blur-[150px] opacity-10 pointer-events-none" data-id="element-117" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-118">
        <div className="bg-forest-700/80 backdrop-blur-md border-2 border-gold-500 rounded-2xl md:rounded-3xl p-6 md:p-16 text-center shadow-[0_0_50px_rgba(212,168,67,0.15)]" data-id="element-119">
          <h2 className="text-2xl md:text-5xl font-serif font-bold text-cream-100 mb-4 md:mb-6" data-id="element-120">
            Recupera Tus Noches Hoy Mismo
          </h2>

          <p className="text-lg md:text-xl text-cream-200 mb-6 md:mb-8 max-w-2xl mx-auto" data-id="element-121">
            Los mercados cierran temprano —{' '}
            <span className="text-gold-400 font-bold" data-id="element-122">
              tu ciclo empieza esta noche.
            </span>
          </p>

          <div className="flex flex-col items-center justify-center mb-6 md:mb-10" data-id="element-123">
            <span className="text-cream-300 text-lg line-through mb-2" data-id="element-124">
              $47 USD
            </span>
            <div className="flex items-baseline gap-2" data-id="element-125">
              <span className="text-5xl md:text-7xl font-bold text-gold-500 font-serif" data-id="element-126">
                $17
              </span>
              <span className="text-xl text-cream-200 font-medium" data-id="element-127">USD</span>
            </div>
            <span className="bg-green-900/50 text-green-400 px-3 py-1 rounded-full text-sm font-medium mt-4 border border-green-800" data-id="element-128">
              Acceso Inmediato • Oferta Limitada
            </span>
          </div>

          <motion.a href="https://pay.hotmart.com/W104639528D" target="_blank" rel="noopener noreferrer" onClick={() => trackAddToCart()} whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="w-full md:w-auto bg-gold-500 hover:bg-gold-400 text-forest-900 font-bold text-lg md:text-2xl px-8 md:px-10 py-5 md:py-6 rounded-xl shadow-[0_0_30px_rgba(212,168,67,0.4)] hover:shadow-[0_0_50px_rgba(212,168,67,0.6)] transition-all mb-4 md:mb-6 flex items-center justify-center gap-3 mx-auto" data-id="element-129">
            COMPRA AHORA — DUERME MAÑANA
          </motion.a>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-6 text-sm text-cream-300/70 mt-6 md:mt-8" data-id="element-130">
            <div className="flex items-center gap-2" data-id="element-131">
              <Lock className="w-4 h-4" data-id="element-132" />
              <span data-id="element-133">Pago 100% Seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-134">
              <Shield className="w-4 h-4" data-id="element-135" />
              <span data-id="element-136">Garantía de 7 días</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-137">
              <CreditCard className="w-4 h-4" data-id="element-138" />
              <span data-id="element-139">Acceso Instantáneo</span>
            </div>
          </div>

          <div className="mt-6 md:mt-10 pt-6 md:pt-8 border-t border-forest-600/50" data-id="element-140">
            <div className="flex items-center justify-center gap-3 mb-2" data-id="element-141">
              <Shield className="w-6 h-6 text-gold-500" data-id="element-142" />
              <span className="font-bold text-cream-100" data-id="element-143">
                Garantía de Hierro
              </span>
            </div>
            <p className="text-cream-300 text-sm max-w-md mx-auto" data-id="element-144">
              Prueba el protocolo por 7 días. Si no duermes mejor, te devolvemos
              el 100% de tu dinero. Sin preguntas. Bajo riesgo total.
            </p>
          </div>
        </div>
      </div>
    </section>;
}